export enum WeeekTabsEnum {
  SettingsToken = "import-weeek_token",
  Statuses = "import-weeek_statuses",
  Priorities = "import-weeek_priorities",
  Types = "import-weeek_types",
  Tags = "import-weeek_tags",
}
